import { __extends } from "tslib";
import { SendUsersMessagesRequest, SendUsersMessagesResponse } from "../models/models_1";
import { deserializeAws_restJson1SendUsersMessagesCommand, serializeAws_restJson1SendUsersMessagesCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
/**
 * <p>Creates and sends a message to a list of users.</p>
 */
var SendUsersMessagesCommand = /** @class */ (function (_super) {
    __extends(SendUsersMessagesCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function SendUsersMessagesCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    SendUsersMessagesCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PinpointClient";
        var commandName = "SendUsersMessagesCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: SendUsersMessagesRequest.filterSensitiveLog,
            outputFilterSensitiveLog: SendUsersMessagesResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    SendUsersMessagesCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1SendUsersMessagesCommand(input, context);
    };
    SendUsersMessagesCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1SendUsersMessagesCommand(output, context);
    };
    return SendUsersMessagesCommand;
}($Command));
export { SendUsersMessagesCommand };
//# sourceMappingURL=SendUsersMessagesCommand.js.map